module.exports = "/_next/static/images/f1cbc602d0196227da4a97763d43a176-rewards-hosting@0.75x.png";